import { css } from 'styled-components';

export const scrollbar = css`
  ${({ theme }) => css`
    /* Modern browsers with \`scrollbar-*\` support */
    @supports (scrollbar-width: auto) {
      scrollbar-color: ${theme.colors.primary} ${theme.colors.lightGrey};
    }

    /* Legacy browsers with \`::-webkit-scrollbar-*\` support */
    @supports selector(::-webkit-scrollbar) {
      &::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
      }
      &::-webkit-scrollbar-track {
        background: ${theme.colors.lightGrey};
      }
    }
  `}
`;
